const initialState = {
    all_products: [],
};

const productReducers = (state = initialState, action) => {
    switch (action.type) {
        case "ALL_PRODUCTS":
            return {
                ...state,
                all_products: action.payload,
            };


        default:
            return state;
    }
};

export default productReducers;
